import axios from 'axios';
import url from '@/url';

const authHeaders = () => ({
  headers: {
    'X-Authorization': localStorage.getItem('token'),
  },
});

const unwrap = (response) => {
  const result = response?.data?.result;
  if (result && (result.status === 200 || result.status === 201)) {
    return result.data;
  }
  return null;
};

/**
 * Every tenant with its force-update config, in a single request.
 * Each row is { tenant: {id, code, name, is_active}, config: { CODE: value|null } }.
 */
export const listAppUpdateConfigs = async () => {
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + url.app_update_configs,
    authHeaders(),
  );
  const data = unwrap(response);
  // Backend wraps response as { data: [ ... ] } — unwrap one level.
  return data?.data ?? data ?? [];
};

/**
 * Update one tenant's force-update config.
 * Only send the codes you intend to change; an omitted code is left untouched.
 * Sending null / '' deletes the row, which turns the gate off for that platform.
 */
export const upsertTenantAppUpdateConfig = async (tenantId, payload) => {
  const response = await axios.put(
    `${process.env.VUE_APP_SERVICE_URL}${url.tenant_app_update_config}${tenantId}/app-update-config`,
    payload,
    authHeaders(),
  );
  const data = unwrap(response);
  return data?.data ?? data ?? {};
};

/**
 * Push the same values to every tenant at once. Returns the refreshed full list.
 * Same omit-to-preserve semantics as the single-tenant call — a field the operator
 * left blank must not be sent, or it would overwrite every branch's value.
 */
export const applyAppUpdateConfigToAll = async (payload) => {
  const response = await axios.put(
    process.env.VUE_APP_SERVICE_URL + url.app_update_configs_apply_all,
    payload,
    authHeaders(),
  );
  const data = unwrap(response);
  return data?.data ?? data ?? [];
};
